/**
 * Aventross (my_preset / sg / aventross) — 자체완결 모듈.
 *
 *   my_preset/sg/aventross/
 *     agm-audited/            AGM (Audited Companies) — 원본 합본 1파일 문서 컴포넌트(docs) + 반복 입력(useRepeat)
 *       components/PreSetAventrossAgmAuditedPanel.vue
 *       chatflows/aventrossAgmAuditedFlow.ts
 *       utils/normalizeAventrossAgmForWord.ts
 *     (cdd/CddVarField/useCddFill/AgmSigners 는 aura/agm 재사용 — Singapura 와 같은 방식)
 *
 * 배선: main.ts 의 `import '@/features/startTask/my_preset/sg/aventross'` 로 로드 시 자동 등록.
 *   매칭 = task code CAV001 (Aventross 접두어 CAV, 코드 전용).
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAventrossAgmAuditedPanel from './agm-audited/components/PreSetAventrossAgmAuditedPanel.vue';
import { aventrossAgmAuditedFlow } from './agm-audited/chatflows/aventrossAgmAuditedFlow';

export const AVENTROSS_AGM_AUDITED_TASK_CODES: string[] = ['CAV001'];

export function matchesAventrossAgmAudited(sel: PreSetSelection): boolean {
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AVENTROSS_AGM_AUDITED_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAventrossAgmAuditedPreset(): void {
  registerChatFlow(aventrossAgmAuditedFlow);
  registerPanel({
    id: 'aventross-agm-audited',
    priority: 55,
    match: (sel) => matchesAventrossAgmAudited(sel),
    component: PreSetAventrossAgmAuditedPanel,
    meta: { docType: 'SG_AVENTROSS_AGM_AUDITED', studio: true },
  });
}

registerAventrossAgmAuditedPreset();
